import { useState, useEffect } from "react";
import axios from "axios";
import AddDocument from "../../forms/document/AddDocumentType";
import Modal from "../../components/Modal";
import { useLocation } from "react-router-dom";

import { GetDocument } from "../../Services";

const DocumentList = () => {
  const [documentType, setDocumentType] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingDocument, setEditingDocument] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const location = useLocation();
  const { driver } = location.state || {};

  useEffect(() => {
    const fetchDocumentType = async () => {
      setLoading(true);
      try {
        const data = await GetDocument.fetchDocumentType();
        setDocumentType(Array.isArray(data.data) ? data.data : []);

        // console.log("Vehicles", data);
      } catch (error) {
        console.error("Error fetching dispatcher:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDocumentType();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <h2 className="text-2xl font-bold">Document Management</h2>
      </div>

      <div className="card">
        <div className="card-header flex items-center justify-between">
          <button
            type="button"
            onClick={() => {
              setEditingDocument(null);
              setShowModal(true);
            }}
            className="btn btn-primary btn-sm flex items-center"
          >
            <i className="fa fa-file mr-1"></i> Add Document
          </button>
        </div>

        <Modal showModal={showModal} setShowModal={setShowModal}>
          <AddDocument
            setDocuments={setDocumentType} // Pass the setDocuments function
            setShowModal={setShowModal} // Pass the setShowModal function
          />
        </Modal>

        <div className="card-body flex flex-col gap-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex gap-4">
              <button type="button" className="btn btn-outline-secondary">
                CSV
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                Excel
              </button>
              <button type="button" className="btn btn-outline-secondary ml-2">
                PDF
              </button>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              style={{ width: "300px" }}
            />
          </div>
          <div className="mt-4">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Document Name</th>
                    <th>Applies For</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {documentType.map((document) => (
                    <tr key={document.id}>
                      <td>{document.id}</td>
                      <td>{document.name}</td>
                      <td>{document.appliesTo}</td>
                      <td>{document.description}</td>
                      <td>
                        <span
                          style={{
                            color:
                              document.status === "ACTIVE" ? "green" : "red",
                            backgroundColor:
                              document.status === "ACTIVE"
                                ? "#d4edda"
                                : "#f8d7da", // Light green for active, light red for inactive
                            padding: "2px 5px", // Add some padding around the text
                            borderRadius: "4px", // Optional: Add rounded corners
                          }}
                        >
                          {document.status === "ACTIVE" ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary mr-1"
                          onClick={() => {
                            setEditingDocument(document);
                            setShowModal(true);
                          }}
                        >
                          <i className="fas fa-edit"></i>
                        </button>

                        <button
                          className="btn btn-sm btn-danger"
                          // onClick={() => handleDelete(driver.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) handlePageChange(currentPage - 1);
                  }}
                >
                  &laquo;
                </a>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  className={`page-item ${
                    currentPage === page + 1 ? "active" : ""
                  }`}
                  key={page + 1}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(page + 1);
                    }}
                  >
                    {page + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      handlePageChange(currentPage + 1);
                  }}
                >
                  &raquo;
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentList;
